import ItemWisePurchaseList from "./ItemWisePurchaseList";

const ItemWisePurchaseRoutes = [
    {
        path: "/ItemWisePurchase/item-wise-purchase-list",
        component: ItemWisePurchaseList,
        permission: "Permissions.Purchases.ItemWisePurchase",
      },
];
export default ItemWisePurchaseRoutes;